import { render, staticRenderFns } from "./AsientosLiberados.vue?vue&type=template&id=1b46bd28&scoped=true"
import script from "./AsientosLiberados.vue?vue&type=script&lang=js"
export * from "./AsientosLiberados.vue?vue&type=script&lang=js"
import style0 from "./AsientosLiberados.vue?vue&type=style&index=0&id=1b46bd28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b46bd28",
  null
  
)

export default component.exports